export const mallOrderStateEnum = [
    {
        stateId: "UNPAID",
        stateName: "待付款"
    },
    {
        stateId: "PENDING_SHIPMENT",
        stateName: "待发货"
    },
    // {
    //     stateId: "SHIPPED",
    //     stateName: "已发货"
    // },
    {
        stateId: "RECEIVING",
        stateName: "待收货"
    },
    // {
    //     stateId: "CANCELLED",
    //     stateName: "已取消"
    // },
    // {
    //     stateId: "CLOSED",
    //     stateName: "已关闭"
    // },
    // {
    //     stateId: "COMPLETED",
    //     stateName: "已完成"
    // },
    // {
    //     stateId: "REFUNDING",
    //     stateName: "退款中"
    // },
    // {
    //     stateId: "REFUNDED",
    //     stateName: "已退款"
    // },
    {
        stateId: "AFTER_SALE",
        stateName: "售后中"
    }
]
